import ReportsPageFieldsWrapperView from './reports-page-fields-wrapper-view'

export default ReportsPageFieldsWrapperView

